import { render, staticRenderFns } from "./PassEventsDiscount.vue?vue&type=template&id=538415d4"
import script from "./PassEventsDiscount.vue?vue&type=script&lang=js"
export * from "./PassEventsDiscount.vue?vue&type=script&lang=js"
import style0 from "./PassEventsDiscount.vue?vue&type=style&index=0&id=538415d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports